import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { getSentryConfig } from './getSentryConfig';
import { getCookie } from '@common/stores/cookie';
import { useBaseStore } from '@common/stores/storage';

export const sentryStart = (Vue, router) => {
  /**  如果是开发环境，不处理错误，直接控制台暴露 */
  if (process.env.IS_DEV) return;
  const { ignoreErrors = [], dsnUrl: dsn, isOnline = false } = getSentryConfig() ?? {};

  if (dsn) {
    Sentry.init({
      Vue,
      dsn,
      release: process.env.SENTRY_VERSION,
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      tracesSampleRate: 0.4,
      // 忽略异常chunk加载异常、fetch请求异常
      ignoreErrors: ignoreErrors,
      beforeSend(event, hint) {
        try {
          const err = hint?.originalException;
          if (err?.target?.tagName !== 'IFRAME') {
            return event;
          }

          const iframe = err.target;

          // 名字优先级：name > id > src 前缀 > 兜底
          const name =
            iframe.name ||
            iframe.id ||
            iframe.src.split(/[?,#]/)[0].split('/').pop().slice(0, 20) ||
            iframe.srcdoc?.slice(0, 20).replace(/[^a-z]/g, '') ||
            'inline';

          event.tags = event.tags || {};
          event.tags.source = `iframe:${name}`;
          event.extra = {
            ...event.extra,
            iframe_src: iframe.src ? iframe.src.split(/[?,#]/)[0] : 'srcdoc',
            iframe_name: iframe.name,
          };

          return event;
        } catch (error) {
          return event;
        }
      },
    });
  }
  Sentry.setTag(
    'envName',
    isOnline ? document.body.dataset?.envName || getCookie('inlinegray') || 'online' : 'test',
  );
  Sentry.setTag('terminalType', window.MsAtom?.getTerminalTypePure?.());
  Sentry.setUser({
    id: useBaseStore().userId,
  });
};
